import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1j8hn28";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'td';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const DayCell = ({
  children
}) => <Container>
    {children}
  </Container>;

require("./day_cell.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./day_cell.js");